/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Viewabledate1Inputs */

const id_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Dapat Dilihat`)
};

const ms_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Boleh Dilihat`)
};

const da_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synlighedsdato`)
};

const de_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeitsdatum`)
};

const en_us2_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewable Date`)
};

const es_es2_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha visible`)
};

const es_mx2_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha visible`)
};

const fil_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa na Maaaring Makita`)
};

const fr_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de visibilité`)
};

const it_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visualizzabile`)
};

const hu_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megtekinthető dátum`)
};

const nl_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zichtbare datum`)
};

const no_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synlig dato`)
};

const pl_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data widoczności`)
};

const pt_br2_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visível`)
};

const pt_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visível`)
};

const ro_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data vizibilă`)
};

const fi_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näkyvä päivä`)
};

const sv_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synligt datum`)
};

const vi_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hiển thị`)
};

const tr_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntülenme Tarihi`)
};

const cs_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum zobrazení`)
};

const bg_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на видимост`)
};

const ru_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата отображения`)
};

const uk_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата показу`)
};

const ar_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الظهور`)
};

const hi_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य तारीख़`)
};

const th_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่มองเห็น`)
};

const ja_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示可能日`)
};

const zh_cn2_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可见日期`)
};

const zh_hant1_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可見日期`)
};

const ko_search_sort_viewabledate1 = /** @type {(inputs: Search_Sort_Viewabledate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표시일`)
};

/**
* | output |
* | --- |
* | "Viewable Date" |
*
* @param {Search_Sort_Viewabledate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_viewabledate1 = /** @type {((inputs?: Search_Sort_Viewabledate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Viewabledate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_viewabledate1(inputs)
	if (locale === "ms") return ms_search_sort_viewabledate1(inputs)
	if (locale === "da") return da_search_sort_viewabledate1(inputs)
	if (locale === "de") return de_search_sort_viewabledate1(inputs)
	if (locale === "en-US") return en_us2_search_sort_viewabledate1(inputs)
	if (locale === "es-ES") return es_es2_search_sort_viewabledate1(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_viewabledate1(inputs)
	if (locale === "fil") return fil_search_sort_viewabledate1(inputs)
	if (locale === "fr") return fr_search_sort_viewabledate1(inputs)
	if (locale === "it") return it_search_sort_viewabledate1(inputs)
	if (locale === "hu") return hu_search_sort_viewabledate1(inputs)
	if (locale === "nl") return nl_search_sort_viewabledate1(inputs)
	if (locale === "no") return no_search_sort_viewabledate1(inputs)
	if (locale === "pl") return pl_search_sort_viewabledate1(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_viewabledate1(inputs)
	if (locale === "pt") return pt_search_sort_viewabledate1(inputs)
	if (locale === "ro") return ro_search_sort_viewabledate1(inputs)
	if (locale === "fi") return fi_search_sort_viewabledate1(inputs)
	if (locale === "sv") return sv_search_sort_viewabledate1(inputs)
	if (locale === "vi") return vi_search_sort_viewabledate1(inputs)
	if (locale === "tr") return tr_search_sort_viewabledate1(inputs)
	if (locale === "cs") return cs_search_sort_viewabledate1(inputs)
	if (locale === "bg") return bg_search_sort_viewabledate1(inputs)
	if (locale === "ru") return ru_search_sort_viewabledate1(inputs)
	if (locale === "uk") return uk_search_sort_viewabledate1(inputs)
	if (locale === "ar") return ar_search_sort_viewabledate1(inputs)
	if (locale === "hi") return hi_search_sort_viewabledate1(inputs)
	if (locale === "th") return th_search_sort_viewabledate1(inputs)
	if (locale === "ja") return ja_search_sort_viewabledate1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_viewabledate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_viewabledate1(inputs)
	return ko_search_sort_viewabledate1(inputs)
});
export { search_sort_viewabledate1 as "search.sort.viewableDate" }